import React, { FC } from 'react';
import { useParams } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

import blogPosts, { tagColors } from './BlogPosts';
import { HourglassIcon } from 'components/hourglassIcon/HourglassIcon';
import { SEO } from 'components/seo/SEO';
import { articleJsonLd, breadcrumbJsonLd } from 'components/seo/organizationSchema';
import './Blog.css';

export const BlogPostPage: FC = () => {
  const { id } = useParams<{ id: string }>();
  const post = blogPosts.find((p) => p.id === id);

  if (!post) return <div className="blog-post-not-found">Post not found.</div>;

  const youtubeSrc = `${process.env.PUBLIC_URL}/assets/socialMedia/youtube.png`;
  const tiktokSrc = `${process.env.PUBLIC_URL}/assets/socialMedia/tiktok.png`;
  const linkedinSrc = `${process.env.PUBLIC_URL}/assets/socialMedia/linkedin.png`;
  const instagramSrc = `${process.env.PUBLIC_URL}/assets/socialMedia/instagram.png`;
  // const emailSrc = `${process.env.PUBLIC_URL}/assets/socialMedia/web.png`;
  const redditSrc = `${process.env.PUBLIC_URL}/assets/socialMedia/reddit.png`;

  const path = `/blog/${post.id}`;
  // post.date is display format ("30 Jun 2025"); structured data needs YYYY-MM-DD
  const isoDate = new Date(post.date).toLocaleDateString('en-CA');

  return (
    <div className="blog-post-container">
      <SEO
        title={`${post.title} — Toastie Health`}
        description={post.subtitle}
        path={path}
        jsonLd={[
          articleJsonLd({ title: post.title, description: post.subtitle, path, datePublished: isoDate }),
          breadcrumbJsonLd([
            { name: 'Home', path: '/' },
            { name: 'Blog', path: '/blog' },
            { name: post.title, path },
          ]),
        ]}
      />
      <div className="blog-post-header">
        <div className="blog-post-tag"
          style={{ backgroundColor: `var(--${tagColors[post.tag]}200)`, color: `var(--${tagColors[post.tag]}800)` }}
        >{post.tag}</div>
        <h1 className="blog-post-title">{post.title}</h1>
        <h5 className="blog-post-subtitle">{post.subtitle}</h5>
        <p className="blog-post-date">{post.date} &nbsp; • &nbsp; <HourglassIcon />{post.readTime} read</p>
      </div>
      <img src={post.image} alt={post.title} className={`blog-post-image ${post.photo ? 'photo' : ''}`} />
      <div className="blog-post-body">
        <ReactMarkdown
          remarkPlugins={[remarkGfm]}
          // Wrapped so the table can fill the width while the wrapper scrolls and rounds the corners
          components={{ table: ({ node, ...props }) => <div className="blog-post-table"><table {...props} /></div> }}
        >{post.content}</ReactMarkdown>
      </div>
      
      <div className="social-media">
        <p>Come say hi!</p>
        <div className="footer-socials">
          <a href="https://tiktok.com/@toastiehealth" target="_blank" rel="noopener noreferrer">
            <img src={tiktokSrc} alt='tiktok' />
          </a>
          <a href="https://instagram.com/toastiehealth" target="_blank" rel="noopener noreferrer">
            <img src={instagramSrc} alt='Instagram' />
          </a>
          <a href="https://www.linkedin.com/company/toastie" target="_blank" rel="noopener noreferrer">
            <img src={linkedinSrc} alt='linkedin' />
          </a>
          <a href="https://www.youtube.com/@toastiehealth" target="_blank" rel="noopener noreferrer">
            <img src={youtubeSrc} alt='youtube' />
          </a>
          <a href="https://www.reddit.com/r/ToastieHealth/" target="_blank" rel="noopener noreferrer">
              <img src={redditSrc} alt='reddit' />
          </a>
        </div>
      </div>
  
    </div>
  );
}
